
export default {
    inserted: function (el, binding) {
        const node = binding.modifiers.parent ? el.parentNode : el
        binding.value(node.offsetHeight < node.scrollHeight)
    }
};